/**
 * @file starter-hints.ts
 * @description «На странице остался текст шаблона» в окне публикации
 * страниц (phase19.28 этап А; решение пользователя 2026-10-24 по
 * uiux-starter-site, вопрос 2): подсказки [З] стартового шаблона,
 * оставшиеся в секциях черновика. Это предупреждение, не запрет (SB120):
 * публиковать можно. Поиск — общий `findStarterHintsInPayload` (shared),
 * здесь — обход блоков страницы и текст строки (до 3 цитат и «ещё N»).
 */

import { findStarterHintsInPayload, type SectionPayload } from "@chaiberi/shared";

import type { SitePageBlock } from "../api-site-pages";

/** Сколько цитат показать, остальное — «и ещё N». */
export const STARTER_HINTS_SHOWN = 3;

/** Подсказки шаблона в включённых секциях страницы — по порядку, без повторов. */
export function starterHintsOfBlocks(blocks: readonly SitePageBlock[]): string[] {
  const found: string[] = [];
  for (const block of blocks) {
    // Выключенный и прежний (неподдерживаемый) блок на сайте не виден.
    if (block.type !== "SECTION" || block.legacy || !block.isEnabled) continue;
    for (const hint of findStarterHintsInPayload(block.payload as SectionPayload)) {
      if (!found.includes(hint)) found.push(hint);
    }
  }
  return found;
}

/** «На странице остался текст шаблона: «…», «…», «…» и ещё 2»; пусто — null. */
export function starterHintsText(hints: readonly string[], shown = STARTER_HINTS_SHOWN): string | null {
  if (hints.length === 0) return null;
  const quoted = hints.slice(0, shown).map((hint) => `«${hint}»`).join(", ");
  const rest = hints.length - shown;
  return `На странице остался текст шаблона: ${quoted}${rest > 0 ? ` и ещё ${rest}` : ""}`;
}
